import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { loginRequest } from './auth-config';
import api from './api/api';
import Login from './pages/Login';
import Admin from './pages/Admin';
import User from './pages/User';
import Logs from './pages/Logs';

function AuthenticatedApp() {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isAuthenticated || ready) return;
    const request = { ...loginRequest, account: accounts[0] };

    async function acquireAndLogin() {
      try {
        const response = await instance.acquireTokenSilent(request);
        sessionStorage.setItem('Token', response.idToken);
      } catch (err) {
        if (err instanceof InteractionRequiredAuthError) {
          instance.loginRedirect(loginRequest);
          return;
        }
        setError(err.message || 'Authentication failed');
        return;
      }
      try {
        const res = await api.post('/auth/login', {});
        const { user, token } = res.data;
        sessionStorage.setItem('Token', token);
        sessionStorage.setItem('user', JSON.stringify(user));
        setReady(true);
      } catch (err) {
        const msg = 'Authentication failed';
        console.error('[LOGIN ERROR]', msg, err.response?.data);
        setError(msg);
        sessionStorage.clear();
      }
    }

    acquireAndLogin();
  }, [isAuthenticated]); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <BrowserRouter><Login errorMessage={error} /></BrowserRouter>;
  if (!ready) return <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', fontFamily:'sans-serif', color:'#810055' }}>Signing you in...</div>;

  const user = JSON.parse(sessionStorage.getItem('user') || '{}');
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={user.role === 'USER' ? <Navigate to="/user" replace /> : <Navigate to="/admin" replace />} />
        <Route path="/user"  element={<User />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/logs"  element={<Logs />} />
      </Routes>
    </BrowserRouter>
  );
}

function MockApp() {
  const token = sessionStorage.getItem('Token');
  const user = JSON.parse(sessionStorage.getItem('user') || '{}');
  if (!token) return <Login />;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={user.role === 'USER' ? <Navigate to="/user" replace /> : <Navigate to="/admin" replace />} />
        <Route path="/user"  element={<User />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/logs"  element={<Logs />} />
        <Route path="*"      element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  const [isMock, setIsMock] = useState(sessionStorage.getItem('Token') === 'mock-token');

  useEffect(() => {
    const onStorage = () => setIsMock(sessionStorage.getItem('Token') === 'mock-token');
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  if (isMock) return <MockApp />;
  return (
    <>
      <AuthenticatedTemplate>
        <AuthenticatedApp />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<Login />} />
          </Routes>
        </BrowserRouter>
      </UnauthenticatedTemplate>
    </>
  );
}
